"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExperienceBar;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MainMenuModule = _interopRequireDefault(require("../../MainMenu.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExperienceBar(_ref) {
  var _ref$exp = _ref.exp,
      exp = _ref$exp === void 0 ? 0 : _ref$exp,
      _ref$expMax = _ref.expMax,
      expMax = _ref$expMax === void 0 ? 0 : _ref$expMax,
      _ref$showValueOnHover = _ref.showValueOnHover,
      showValueOnHover = _ref$showValueOnHover === void 0 ? false : _ref$showValueOnHover,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.experienceBar, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_MainMenuModule.default.bar, _MainMenuModule.default.exp, showValueOnHover && _MainMenuModule.default.showValueOnHover)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _MainMenuModule.default.fill,
    style: {
      width: "".concat(100 * exp / expMax, "%")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _MainMenuModule.default.value
  }, exp, " / ", expMax)));
}